<template>
    <div class="wrap">
        <title> Privacy policy</title>
  
  

    <h1>PRIVACY POLICY</h1>

    <h2>1. Purposes of the processing</h2>

        We inform that all personal data provided by the User through this 
    app (hereinafter, the "App") will be processed by OWQLO, S.L, as Data 
    Controller of the processing, (hereinafter, "OWQLO") for the following 
    purposes:

        <ul style="list-style-type:none">
        <li>A.	Enable the provision of requested services; The legal basis
    for carrying out this data processing is the execution of the 
    contractual obligations assumed by the User and OWQLO in the App. The 
    personal data processed for this purpose will be kept as long as that 
    relationship is maintained and, once it is finalized, during the 
    conservation and prescription periods of the legal liabilities.</li> <br>
        <li>B.	Keep you informed, including by electronic means, about 
    news and events related to OWQLO, as well as OWQLO products and 
    services. The legal basis for carrying out this data processing is the 
    freely given consent of the User. Personal data processed for this 
    purpose will be kept until the User withdraws the given consent. The 
    User may indicate expressly whether or not it authorizes the processing 
    of their data at any time.</li>
        </ul>



  <h2>2. Recipients, Data Processors and personal data transfers</h2>

        Personal data may be communicated to the following third-party 
    recipients: Public Administrations for compliance with legal 
    obligations; and to the following categories of Data Processors: 
    Providers of electronic communications; Suppliers of IT development and 
    online office automation, hosting, SaaS services such as CRM/ERP, 
    accounting, auditing and lawyers. OWQLO may also transfer the personal 
    data to Data Processors located in the United States of America who are 
    members of the Privacy Shield, which has a decision to adopt the 
    European Commission (Execution Decision (EU) 2016/1250 of the 
    Commission).

    <h2>3. Rights of the Users</h2>

        The interested party is, at any time, entitled to exercise the 
    rights of access, rectification, erasure, restriction of processing, 
    data portability and object by email addressed to support@owqlo.com or 
    by letter addressed to OWQLO, C/Fernando El Santo, nº 27, 4º A 28010 - 
    Madrid (Spain). The users have the right to withdraw consent at any 
    time, without affecting the lawfulness of processing based on consent 
    before its withdrawal. The users have, as well, the right to lodge a 
    complaint with a supervisory authority.

    <h2>4. Display of User data by other Users</h2>

    The User knows and accepts that when registering in the App, other Users will be able to visit and view their profile.

    <h2>5. Under-age Users</h2>

    When the User is under 14 years old, will be required the consent of
    their respective legal guardians in order to get signed up in the App. 
    They will must enter their name, surname, email address and the number 
    of their national identity document at the time of registration in the 
    App. After, said legal guardian will have to verify it through the 
    e-mail address previously provided.

    <h2>6. OWQLO as Data Processor</h2>

    OWQLO will be the Data Processor of all those User?s personal data 
    that needs to be accessed for the correct provision of the requested 
    services, except those already treated in section 1 of this Privacy 
    Policy.

    Said personal data may be classified into the following categories 
of data:    
    <ul style="list-style-type:none">
      <li>1.	Identification data.</li>
      <li>2.	Personal characteristics data.</li>
      <li>3.	Academic and professional data.</li>
      <li>4.	Data related to health.</li>
    </ul>




    In this regard, OWQLO undertakes:
    <ul style="list-style-type:none">
      <li>a) Processing personal data only following documented 
    instructions from the User, including with regard to transfers of 
    personal data, unless required to do so by Union or Member State law; in
    such case, the Processor will inform User of that legal requirement 
    before processing, unless that Law prohibits such information on 
    important grounds of public interests.</li><br>
        <li>b) Ensure that the persons authorised to process personal data
    have committed themselves to confidentiality or are under an 
    appropriate statutory obligation of confidentiality. </li><br>
        <li>c) Take all measures required pursuant to Article 32 of the Regulation. </li><br>
        <li>d) When the Data Processor turns to another person in charge 
    to carry out certain treatment activities, he will impose on the other 
    person in charge, by contract, the same data protection obligations as 
    those stipulated in this Contract. e) Assist the User, taking into 
    account the nature of the processing, by appropriate technical and 
    organisational measures, insofar as this is possible, for the fulfilment
    of the User?s obligation to respond to requests for exercising the data
    subject?s rights. In this case, the Processor must communicate it by 
    email to the following address. The communication must be made 
    immediately.</li><br>
        <li>f) Assists the User in ensuring compliance with the 
    obligations pursuant to Articles 32 to 36 taking into account the nature
    of processing and the information available to the Processor. g) At the
    choice of the User, deletes or returns all the personal data to the 
    User after the end of the provision of services relating to processing, 
    and deletes existing copies unless Union or Member State law requires 
    storage of the personal data.</li><br>
        <li>h) Makes available to the User all information necessary to 
    demonstrate compliance with the obligations laid down in Article 28 of 
    the Regulation. </li><br>
        <li>i) Inform the User immediately if, in the opinion of the 
    Processor, when an instruction infringes the Regulation or other data 
    protection rule from the Union or Member State.</li><br>
        <li>j) Comply with any other obligation set by the current data protection regulations. </li><br>
        <li> k) Notify to the User, without undue delay and where 
    feasible, through email, any personal data breach with all the relevant 
    information for the documentation, resolution and communication of the 
    incident.</li><br>
    </ul>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.wrap {
    padding: 10%;
}
</style>


// WEBPACK FOOTER //
// src/auth/docs/privacyPolicy.vue?538f2139